import { Grid, Select, Text } from '@mantine/core';

const AiModelSettings = ({ model, handleChange, showInfoText, colSm }) => {
  const options = [
    { label: 'GPT 3.5 Turbo', value: 'gpt-3.5-turbo' },
    { label: 'GPT 4', value: 'gpt-4' },
    { label: 'GPT 4 Turbo', value: 'gpt-4-1106-preview' },
    { label: 'BgGPT - Bulgarian', value: 'BgGPT-7B-Instruct-v0.2' },
    { label: 'Mixtral - English, French, Italian, Spanish, German', value: 'Mixtral-8x7B-DPO-AWQ' },
  ];

  return (
    <>
      <Grid.Col span={{ base: 12, sm: colSm }}>
        <Select searchable={true} data={options} onChange={(value) => handleChange(value)} value={model} />
        {showInfoText && (
          <Text size="xs" c="dimmed" mt="xs">
            Select a default AI model that will be used for your main AI content generation. You can explore the
            different models in the playground.
          </Text>
        )}
      </Grid.Col>
    </>
  );
};
export default AiModelSettings;
